import React from 'react'
import Box from '@mui/material/Box'
import EventRounded from '@mui/icons-material/EventRounded'
import Timelapse from '@mui/icons-material/Timelapse'
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined'
import VerifiedRounded from '@mui/icons-material/VerifiedRounded'
import MapSubtitleItem from './map-subtitle-item'

const MapSubtitle: React.FC = () => {
  return (<Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: '16px', padding: '16px' }}>
    <MapSubtitleItem color='#8E8E8E' text='A realizar'>
      <EventRounded />
    </MapSubtitleItem>
    <MapSubtitleItem color='#0245CC' text='Em andamento'>
      <Timelapse />
    </MapSubtitleItem>
    <MapSubtitleItem color='#018923' text='Finalizado'>
      <CheckCircleOutlined />
    </MapSubtitleItem>
    <MapSubtitleItem color='#006100' text='Revisado'>
      <VerifiedRounded />
    </MapSubtitleItem>
  </Box>)
}

export default MapSubtitle
